import { IRoute } from '../interfaces/routing';
import DashboardPage from '../pages/covidVaccination/covidVaccination';
// import addCovidVaccination from '../pages/covidVaccination/addCovidVaccination';
import CovidVaccination from '../pages/covidVaccination/covidVaccination';
import CovidTesting from '../pages/covidTesting/covidTesting';
import DriversQualification from '../pages/drivers_qualification/driversQualification';
import AddCovidTesting from '../pages/covidTesting/addCovidTest';
import Medicalsurveillance from '../pages/MedicalSurveillance/MedicalSurveillance'
import Training from '../pages/Training/Training'
import Profile from '../pages/profile/profile';
import DriversQualificationFront from '../pages/drivers_qualification/driversQualificationFront';
import AddDriverQualification from '../pages/drivers_qualification/addDriverQualification';
// import UpdateCovidVacciantion from '../pages/covidVaccination/UpdateCovidVacciantion';

export const defaultRoutes: IRoute[] = [
  {
    path: 'default-dashboard',
    component: DashboardPage
  },
  {
    path: 'CovidVaccination',
    component: CovidVaccination
  },
  {
    path: 'CovidTesting',
    component: CovidTesting
  },
  {
    path: 'DriverQualification',
    component: DriversQualification
  },
  // {
  //   path: 'addCovidVac',
  //   component: addCovidVaccination
  // },
  // {
  //   path: 'UpdateCovidVacciantion',
  //   component: UpdateCovidVacciantion
  // },
  
  {
    path: 'addCovidTest',
    component: AddCovidTesting
  },
  {
    path: 'addDriverQualification',
    component: AddDriverQualification
  },
  {
    path: 'driversQualificationFront',
    component: DriversQualificationFront
  },
  {
    path: 'medicalsurveillance',
    component: Medicalsurveillance
  },
  {
    path: 'training',
    component: Training
  }
  ,
  {
    path: 'profile',
    component: Profile
  }
];
